<sh-box id="funcloc-box-1" background="surface" layout="vertical" elevation="none" style="height: 100%">

  <!-- Loading Header -->
  @if (isLoading) {
    <sh-box-header id="funcloc-box-header-2" slot="header" padding-bottom="0">
      <sh-icon id="funcloc-icon-manufacturer" style="height: 14px; width: 12px; margin-left: -4px; margin-right: 8px; cursor: help;"
      icon="manufacturer" size="s" (click)="openHelp('Functional Location Overview')"></sh-icon>
      <div style="display: flex; flex-direction: column;flex: 1 1 auto; padding-right: 8px;">
        <sh-text id="funcloc-text-4" size="title-1" style="padding-right: 16px;" style="cursor: help; width: auto"
          (click)="openHelp('Functional Location Overview')">
          {{ 'funcloc.widget.loadingCustomerSite' | transloco }}
        </sh-text>
        <sh-text id="funcloc-text-5" size="body-1">{{ 'funcloc.widget.loadingCustomerSite' | transloco }}</sh-text>
      </div>
      @if (screenInfo$ | async; as screen) {
        <sh-dropdown id="funcloc-dropdown-6" no-border condensed
          style="min-width: 50px; max-width: 100px;" [attr.value]="(selectedRange === 7 ? (screen.size !== 'XLarge' ? ('funcloc.widget.range.7days' | transloco) : ('funcloc.widget.range.last7Days' | transloco)) : selectedRange === 14 ? (screen.size !== 'XLarge' ? ('funcloc.widget.range.14days' | transloco) : ('funcloc.widget.range.last14Days' | transloco)) : (screen.size !== 'XLarge' ? ('funcloc.widget.range.30days' | transloco) : ('funcloc.widget.range.last30Days' | transloco)))">
          <sh-menu-item id="funcloc-menu-item-7" disabled (click)="changeRange(7)"
            [attr.label]="screen.size !== 'XLarge' ? ('funcloc.widget.range.7days' | transloco) : ('funcloc.widget.range.last7Days' | transloco)"
          [active]="selectedRange === 7"></sh-menu-item>
          <sh-menu-item id="funcloc-menu-item-8" disabled (click)="changeRange(14)"
            [attr.label]="screen.size !== 'XLarge' ? ('funcloc.widget.range.14days' | transloco) : ('funcloc.widget.range.last14Days' | transloco)"
          [active]="selectedRange === 14"></sh-menu-item>
          <sh-menu-item id="funcloc-menu-item-9" disabled (click)="changeRange(30)"
            [attr.label]="screen.size !== 'XLarge' ? ('funcloc.widget.range.30days' | transloco) : ('funcloc.widget.range.last30Days' | transloco)"
          [active]="selectedRange === 30"></sh-menu-item>
        </sh-dropdown>
      }
    </sh-box-header>
  }

  <!-- Device Header -->
  @if (type === 'device' && !isLoading) {
    <sh-box-header id="funcloc-box-header-10" slot="header" padding-bottom="0">
      <span style="height: 18px; max-width: 18px; margin-right: 8px; cursor: help;"
        (click)="openHelp('Functional Location Overview')"
      [class]="'fi fis fi-'+site?.country?.toLowerCase() "></span>
      <div style="display: flex;" style="cursor: help;" (click)="openHelp('Functional Location Overview')">
        <sh-text id="funcloc-text-11" size="title-1" style="padding-right: 16px;">
          {{ 'funcloc.widget.locationOfDevice' | transloco }}
        </sh-text>
        <sh-text id="funcloc-text-12" size="body-1" style="padding-right: 16px;">
          {{site?.functional_location}}
        </sh-text>
      </div>
      @if (screenInfo$ | async; as screen) {
        <sh-dropdown id="funcloc-dropdown-13" no-border condensed
          style="min-width: 50px; max-width: 100px;" [attr.value]="(selectedRange === 7 ? (screen.size !== 'XLarge' ? ('funcloc.widget.range.7days' | transloco) : ('funcloc.widget.range.last7Days' | transloco)) : selectedRange === 14 ? (screen.size !== 'XLarge' ? ('funcloc.widget.range.14days' | transloco) : ('funcloc.widget.range.last14Days' | transloco)) : (screen.size !== 'XLarge' ? ('funcloc.widget.range.30days' | transloco) : ('funcloc.widget.range.last30Days' | transloco)))">
          <sh-menu-item id="funcloc-menu-item-14" (click)="changeRange(7)" [attr.label]="screen.size !== 'XLarge' ? ('funcloc.widget.range.7days' | transloco) : ('funcloc.widget.range.last7Days' | transloco)"
          [active]="selectedRange === 7"></sh-menu-item>
          <sh-menu-item id="funcloc-menu-item-15" (click)="changeRange(14)" [attr.label]="screen.size !== 'XLarge' ? ('funcloc.widget.range.14days' | transloco) : ('funcloc.widget.range.last14Days' | transloco)"
          [active]="selectedRange === 14"></sh-menu-item>
          <sh-menu-item id="funcloc-menu-item-16" (click)="changeRange(30)" [attr.label]="screen.size !== 'XLarge' ? ('funcloc.widget.range.30days' | transloco) : ('funcloc.widget.range.last30Days' | transloco)"
          [active]="selectedRange === 30"></sh-menu-item>
        </sh-dropdown>
      }
    </sh-box-header>
  }

  <!-- Site Header -->
  @if (type !== 'device' && !isLoading) {
    <sh-box-header id="funcloc-box-header-17" slot="header" padding-bottom="0">
      <!-- Overlay Icon -->
      <div style="flex: 0 0 18px; position: relative; display: inline-block; width: 18px; height: 18px; margin-right: 8px; cursor: help;"
        (click)="openHelp('Functional Location Overview')">
        <sh-icon id="funcloc-icon-manufacturer" style="height: 14px; width: 12px; margin-left: -4px;" icon="manufacturer" size="s"></sh-icon>
        <span
          style="position: absolute; right: -4px; bottom: -8px; height: 12px; width: 12px; font-size: 12px; line-height: 12px;"
        [class]="'fi fis fi-'+site?.country?.toLowerCase()"></span>
      </div>
      <div style="display: flex; flex-direction: column;flex: 1 1 auto; padding-right: 8px;">
        <sh-text id="funcloc-text-19" size="title-1" style="padding-right: 16px;" style="width: auto">
          {{selectedSite?.Name}}
        </sh-text>
        <sh-text id="funcloc-text-20" size="body-1">{{ 'funcloc.widget.siteOverview' | transloco }}</sh-text>
      </div>
      <!-- Right Slot -->
      <div style="display: flex; justify-content: flex-end; align-items: center; gap: 4px; height: 30px;">
        <sh-icon #siteicon id="siteinformation" icon="information" button size="s" toggle
        (click)="openSite()"></sh-icon>
        @if (!isLoading && site) {
          <sh-popover id="funcloc-popover-detailed-customer-site-in" #sitemenu icon="manufacturer"
            [attr.label]="'funcloc.widget.popover.title' | transloco" passive sticky position="left-up" target="siteinformation"
            overlay-target-distance="1" viewport-padding="0.5" style="width:350px; z-index: 500"
            [visible]="siteOpen" (overlay-closed)="siteClosed()">
            <div style="display: flex; flex-direction: column;">
              <div #toprow style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 16px;">
                <div style="width: calc(100%); display: flex; flex-direction: column; flex: 1 1 auto;">
                  <sh-text id="funcloc-text-22" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'funcloc.widget.popover.customerSiteName' | transloco }}</sh-text>
                  <sh-text id="funcloc-text-23" [ngClass]="'overflow'">{{site.functional_location}}</sh-text>
                </div>
                <div style="width: calc(100%); display: flex; flex-direction: column; flex: 1 1 auto">
                  <sh-text id="funcloc-text-24" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'funcloc.widget.popover.address' | transloco }}</sh-text>
                  <sh-text id="funcloc-text-25" [ngClass]="'overflow'">{{site.address}}</sh-text>
                  <sh-text id="funcloc-text-26" [ngClass]="'overflow'">{{site.zip}} {{site.city}}</sh-text>
                  <sh-text id="funcloc-text-27" [ngClass]="'overflow'">
                    {{site?.country}}
                    <span style="height: 14px; max-width: 18px; margin-right: 4px; cursor: help;"
                    [class]="'fi fis fi-'+site?.country?.toLowerCase() "></span>
                  </sh-text>
                </div>
                <div style="width: calc(100%); display: flex; flex-direction: column; flex: 1 1 100%;">
                  <sh-text id="funcloc-text-28" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'funcloc.widget.popover.supportedSystems' | transloco }}</sh-text>
                  <sh-text id="funcloc-text-29" [ngClass]="'overflow'">{{site.device_data?.length}}</sh-text>
                </div>
              </div>
            </div>
          </sh-popover>
        }
        <span class="bookmark-wrapper" style=" flex: 0 0 auto;">
          @if (!isBookmarked && !errorBookmark && !isLoading && selectedSite) {
            <i
            class="pi pi-bookmark custom-book normal" (click)="updateBookmark($event)"></i>
          }
          @if (isBookmarked && !errorBookmark && !isLoading && selectedSite) {
            <i
            class="pi pi-bookmark-fill custom-book normal" (click)="updateBookmark($event)"></i>
          }
          @if (errorBookmark || !selectedSite || isLoading) {
            <i id="errorbookmark"
            class="pi pi-bookmark custom-book normal disabled"></i>
          }
        </span>
        @if (isError) {
          <sh-tooltip id="funcloc-tooltip-30" target="errorbookmark" placement="left-up">
            {{ 'funcloc.widget.tooltip.bookmarksUnavailable' | transloco }}
          </sh-tooltip>
        }
        @if (!selectedSystem?.SerialNumber || isLoading) {
          <sh-tooltip id="funcloc-tooltip-31" target="errorbookmark" placement="left-up">
            {{ 'funcloc.widget.tooltip.availableUponSelection' | transloco }}
          </sh-tooltip>
        }
        <sh-icon id="funcloc-icon-32" button icon='refresh' size="s" (click)="refresh()" [disabled]="!selectedSite"></sh-icon>
        @if (showSiteRangeDropdown) {
          <sh-divider id="funcloc-divider-33" spacing='s' vertical></sh-divider>
        }
        @if (showSiteRangeDropdown) {
          <sh-dropdown id="funcloc-dropdown-34" no-border condensed
            style="min-width: 50px; flex: 0 0 64px;" [attr.value]="selectedRange === 7 ? '7' : selectedRange === 14 ? '14' : '30'">
            <sh-menu-item id="funcloc-menu-item-7" (click)="changeRange(7)" label="7" [active]="selectedRange === 7"></sh-menu-item>
            <sh-menu-item id="funcloc-menu-item-14" (click)="changeRange(14)" label="14" [active]="selectedRange === 14"></sh-menu-item>
            <sh-menu-item id="funcloc-menu-item-30" (click)="changeRange(30)" label="30" [active]="selectedRange === 30"></sh-menu-item>
          </sh-dropdown>
        }
      </div>
    </sh-box-header>
  }

  @if (isLoading || isError || isEmpty || !hideSiteInstrumentList) {
    <sh-box-section id="funcloc-box-section-38" style="height: 100%">
      @if (isLoading && !isError) {
        <div
          style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
          <sh-spinner id="funcloc-spinner-39" size="s"></sh-spinner>
        </div>
      }
      @if (!isLoading && !isError && site && !hideSiteInstrumentList) {
        <div style="display: flex; flex-direction: column; gap: 8px;">
          @for (instrument of site.device_data | sortAndLimit: type === 'device' ? selectedSystem.SerialNumber : null : limit : type : bpCanMachineData : bpCanServiceData; track instrument['serial_number'] + '-' + instrument['material_number']) {
            <div [ngClass]="'custom-parent'"
              >
              <div [ngClass]="'iconTextContainer'">
                @if (getInstrumentStatus(instrument) === 'success') {
                  <sh-icon id="funcloc-icon-success"
                    icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help"
                  (click)="openHelp('Functional Location')"></sh-icon>
                }
                @if (getInstrumentStatus(instrument) === 'warning') {
                  <sh-icon id="funcloc-icon-warning"
                    icon="warning" size="xs" color="var(--warning-yellow)" style="cursor: help"
                  (click)="openHelp('Functional Location')"></sh-icon>
                }
                @if (getInstrumentStatus(instrument) === 'error') {
                  <sh-icon id="funcloc-icon-error" icon="error" size="xs" style="cursor: help"
                  (click)="openHelp('Functional Location')"></sh-icon>
                }
                <sh-text id="funcloc-text-43" [ngClass]="'custom-info'">{{instrument['serial_number']}}</sh-text>
              </div>
              @if (bpCanMachineData && getSystemHealthIssues(instrument) !== 0) {
                <div
                  [ngClass]=" type !== 'device' ? 'custom-tag' : 'custom-tag nolink'"
                  (click)="onMaximize('site', true)">
                  <!-- <sh-icon id="funcloc-icon-utilities" icon="utilities" size="xs"></sh-icon> -->
                  {{ getSystemHealthIssues(instrument) }} {{ 'funcloc.widget.issues' | transloco }}
                </div>
              }
              @if (bpCanServiceData && getServiceHistoryIssues(instrument.service_history) !== 0) {
                <div
                  [ngClass]=" type !== 'device' ? 'custom-tag' : 'custom-tag nolink'"
                  (click)="onMaximize('site', true)">
                  <!-- <sh-icon id="funcloc-icon-utilities" icon="utilities" size="xs"></sh-icon> -->
                  {{ getServiceHistoryIssues(instrument.service_history) }} {{ 'funcloc.widget.tickets' | transloco }}
                </div>
              }
            </div>
          }
          @if (site?.device_data?.length > 5) {
            <span>...</span>
          }
        </div>
      }
      @if (!isLoading && isError) {
        <sh-empty-state id="funcloc-empty-state-error-retrieving-data" [attr.label]="'funcloc.widget.error' | transloco" icon="error"
        icon-color="#ebebe"></sh-empty-state>
      }
      @if (!isLoading && isEmpty) {
        <sh-empty-state id="funcloc-empty-state-no-data-for-supported-ins" [attr.label]="'funcloc.widget.empty' | transloco" icon="information"
        icon-color="#ebebe"></sh-empty-state>
      }
    </sh-box-section>
  }

  @if (type === 'site' && hideSiteInstrumentList && !isLoading && !isError && !isEmpty) {
    <sh-box-section id="funcloc-box-section-48"
    class="header-only-spacer"></sh-box-section>
  }

  @if (!isLoading && site && showSiteDetailsButton) {
    <sh-box-footer id="funcloc-box-footer-49" slot="footer" padding-top="0" padding-bottom="1rem">
      <!-- Site Button -->
      @if (getDeviceType() !== 'phone' && type === 'site') {
        <sh-button id="funcloc-button-50" (click)="onMaximize(null)"
          [icon]="checkWidgetIcon()" icon-position="right" icon-size="s" [disabled]="site === null"
          [attr.label]="site?.device_data?.length > 5 ? ('funcloc.widget.detailsMore' | transloco:{ count: site?.device_data?.length - 5 }) : ('funcloc.widget.details' | transloco)"
        layout="compact" color="secondary" size="s"></sh-button>
      }
      <!-- Device Button -->
      @if (getDeviceType() !== 'phone' && type === 'device') {
        <sh-button id="funcloc-button-open-link"
          (click)="openWithParams({ siteId: selectedSystem?.Functional_Location_ID})" icon="open-link"
          icon-position="right" icon-size="s" [disabled]="site === null"
          [attr.label]="site?.device_data?.length > 5 ? ('funcloc.widget.goToSiteOverviewMore' | transloco:{ count: site?.device_data?.length - 5 }) : ('funcloc.widget.goToSiteOverview' | transloco)"
        layout="compact" color="secondary" size="s"></sh-button>
      }
      <!--         <sh-button id="funcloc-button-52" *ngIf="!isLoading  && site?.device_data?.length > 5 && type === 'device'" (click)="toggleLimit()"
    [label]="dynamicToggleLabel()" layout="compact" color="tertiary" size="m"></sh-button> -->
  </sh-box-footer>
}

</sh-box>